var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[_c('inertia-link',{attrs:{"href":"/"}},[_c('img',{staticClass:"m-auto p-auto",attrs:{"src":_vm.source,"alt":"SH TAX"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }